import React from 'react';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';

import { PageSeo } from 'components/common';
import { Layout } from 'components/layout';
import { TRANSLATIONS } from 'constants/translations';
import * as SeoHelpers from 'helpers/SeoHelpers';
import { withSSGPage } from 'hoc/WithServerPage/withSSGPage';

import type { NextPageWithLayout } from 'types';
import { PageType } from 'types';

const ContactPageTemplate = dynamic(() => import('templates/StaticPage/ContactPageTemplate'), { ssr: false });

export const getStaticProps = withSSGPage(async () => {
  return {
    props: {}
  };

}, {
  translations: [TRANSLATIONS.COMMON],
  pageType: PageType.Contact,
  revalidate: false
});

const Page: NextPageWithLayout<PageType.Contact> = () => {
  const { t } = useTranslation();

  const pageSeoProps = SeoHelpers.getContactPageSeo(t);

  return (
    <>
      <PageSeo {...pageSeoProps} />
      <ContactPageTemplate />
    </>
  );
};

Page.getLayout = (page) => (
  <Layout>
    {page}
  </Layout>
);

export default Page;
